import { AxiosResponse } from 'axios';
import { ON_FARM_BILLING_AGREEMENT_API_ENDPOINTS } from '../constants/apiEndpoints';
import { appContextGet, appContextPost } from './httpCommon/appAxios.service';
import {
  AcceptOnFarmBillingAgreementRequest,
  AccountOnFarmBillingAgreement,
  OnFarmBillingAgreementStatus,
} from '../types/interfaces/onFarmBillingAgreement.interfaces';

export const getOnFarmBillingAgreementStatus = (accountId?: number): Promise<AxiosResponse<OnFarmBillingAgreementStatus>> => {
  return appContextGet(ON_FARM_BILLING_AGREEMENT_API_ENDPOINTS.STATUS, accountId != null ? { accountId } : undefined);
};

export const acceptOnFarmBillingAgreement = (
  request: AcceptOnFarmBillingAgreementRequest,
): Promise<AxiosResponse<AccountOnFarmBillingAgreement>> => {
  return appContextPost(ON_FARM_BILLING_AGREEMENT_API_ENDPOINTS.ACCEPT, request);
};
